<template>
  <div class="rent-lessee-dialog">
    <custom-dialog :visible="visible"  width="80%" :title="model.title" v-on="$listeners">
      <div class="dialog-body">
        <el-row style="padding-bottom: 10px">
          <el-col :span="6">{{ $t('crm_lessee_rent_dialog.ji_tuan_ming_cheng') }}：{{ data.partnerName }}</el-col>
          <el-col :span="10" :offset="1">{{ $t('crm_lessee_rent_dialog.ji_tuan_di_zhi') }}：{{ data.address }}</el-col>
        </el-row>
        <div class="table-box">
          <el-row :gutter="50">
            <el-col :span="12">
              <div class="search-hd">
                <el-form :inline="true" @submit.native.prevent>
                  <div class="title" style="float: left">
                    <div class="tag centerY"></div>
                    <span>{{ $t('crm_lessee_rent_dialog.wglzlf') }}</span>
                  </div>
                  <!-- 搜索项 -->
                  <el-form-item style="float: right; margin-right: 0">
                    <el-input :placeholder="$t('crm_lessee_rent_dialog.zlfmc')" v-model="formSearch.search" clearable @keyup.enter.native="onPageChange({ page: 1 })" style="width: 280px">
                      <template slot="append">
                        <div @click="onPageChange({ page: 1 })">
                          <i class="icon icon-search"></i>
                        </div>
                      </template>
                    </el-input>
                  </el-form-item>
                </el-form>
              </div>
              <custom-table
                ref="tb1"
                border
                type="checkbox"
                v-model="selectedRentData"
                :size="allTableSize"
                tableCode="related_lessee"
                :data="rentLsseeList"
                height="500px"
                @selection-change="selectionChange($event, 'selectLessee')"
                @sort-change="sortChange"
                @filter-change="filterChange"
                :filterArr="['relationType']"
              >
              </custom-table>
              <!-- <el-table ref="tb1" :data="rentLsseeList" :size="allTableSize" @selection-change="selectionChange($event, 'selectLessee')" @sort-change="sortChange" height="500px">
                <el-table-column type="selection" width="44" fixed="left"></el-table-column>
                <template v-for="(item, index) in tableColumn">
                  <el-table-column
                    v-if="item.selected"
                    :key="index"
                    :index="index"
                    :prop="item.columnCode"
                    :label="item.columnName"
                    :width="item.width"
                    :formatter="item.isFormat ? formatColumn : null"
                    :sortable="item.isSort ? 'custom' : null"
                    :fixed="item.isLock ? 'right' : null"
                    show-overflow-tooltip
                  ></el-table-column>
                </template>
                <el-table-column v-if="!tableColumn.length"></el-table-column>
              </el-table> -->
              <div class="table-page">
                <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="search-hd">
                <div class="title">
                  <div class="tag centerY"></div>
                  <span>{{ $t('crm_lessee_rent_dialog.dglzlf') }}</span>
                </div>
              </div>
              <custom-table
                ref="tb2"
                index
                :size="allTableSize"
                tableCode="related_lessee"
                :data="rentLsseeRight"
                height="500px"
                @selection-change="selectionChange"
                @sort-change="sortChange"
                :slots="['relationType']"
                :empty-text="$t('crm_lessee_rent_dialog.qing_tian_jia')"
              >
                <template v-slot:relationType="scope">
                  <el-select v-model="scope.row.relationType" :placeholder="$t('Common.com_please_select')" style="width: 110px">
                    <el-option :label="$t('crm_lessee_rent_dialog.zi_dong_guan_lian')" :value="1"></el-option>
                    <el-option :label="$t('crm_lessee_rent_dialog.shou_dong_guan_lian')" :value="0"></el-option>
                  </el-select>
                </template>
              </custom-table>
            </el-col>
          </el-row>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">{{ $t('Common.com_cancel') }}</el-button>
        <el-button type="primary" @click="saveLessee">{{ $t('Common.com_confirm') }}</el-button>
      </div>
    </custom-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';

export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    data: [String, Object, Array],
    model: {
      type: Object,
      default() {
        return {
          title: '',
        };
      },
    },
  },
  data() {
    return {
      visible: false,
      selectLessee: [],
      rentLsseeList: [],
      // 右边表格
      rentLsseeRight: [],
      formSearch: {
        partnerId: '',
        search: '',
        pageSize: 20,
        pageNum: 1,
      },
      totalRows: 0,
    };
  },

  mounted() {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.initDialog();
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.$nextTick(() => {
        this.visible = true;
      });
      this.formSearch = JSON.parse(this.resetFormSearch);
      // this.dialogData.partnerId = this.partnerId;
      this.formSearch.partnerId = this.data.partnerId;
      this.getLesseePage();
    },
    // 选中
    selectionChange: function (selection, name) {
      this[name] = selection;
      this.rentLsseeRight = selection;
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close', false);
      }, 250);
    },
    // 获取关联列表
    getLesseePage: function () {
      this.$getJSON(apis.partnerLargeCustomerCustomerUnlinkPage, this.formSearch).then((res) => {
        this.rentLsseeList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 切换页
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getLesseePage();
    },
    // 保存关联
    saveLessee: function () {
      const idArr = this.selectLessee;
      const parameter = {};
      parameter.partnerOrgId = this.data.partnerOrgId;
      parameter.partnerId = this.data.partnerId;
      parameter.largeCustomerPartnerOrgId = this.data.partnerOrgId;
      parameter.customers = idArr;
      this.$postJSON(apis.partnerLargeCustomerCustomerLink, parameter).then(() => {
        this.$message({
          message: this.$t('crm_lessee_rent_dialog.guan_lian_cheng_gong'),
          type: 'success',
        });
        this.$emit('success');
        this.closeDialog();
      });
    },
    // // 切换页
    // onCurrentPage: function (page) {
    //   this.formSearch.pageNum = page;
    //   this.getLesseePage();
    // },
    // // 切换每页数量
    // onSizeChange: function (size) {
    //   this.formSearch.pageSize = size;
    //   this.getLesseePage();
    // },
  },
};
</script>

<style lang="scss">
.rent-lessee-dialog {
  .table-box {
    .title {
      line-height: 24px;
      font-size: 16px;
      padding-left: 10px;
      position: relative;
      color: #595959;
      margin-bottom: 10px;
      .tag {
        width: 4px;
        height: 15px;
        background-color: #00afff;
        left: 0;
      }
    }
  }
}
</style>
